import React from 'react'
import styles from './JumpingBar.module.css'

const JumpingBar = () => {
    return (
        <div className={styles.container}></div>
    )
}

export default JumpingBar
